import React from "react";
import { useDispatch } from "react-redux";
import MultiSelectDropdown from "../../../components/multiSelectDropdown/multiSelectDropdown";
import { changeModulePosition } from "../redux/customChartSagas";

const BASE_ACTIONS = {
  edit: { id: "edit", name: "Edit" },
  delete: { id: "delete", name: "Delete" }
};

const MOVE_ACTIONS = {
  top: { id: "move_up", name: "Move Up" },
  bottom: { id: "move_down", name: "Move Down" }
};

const getPositionActions = (position) => {
  switch (position) {
    case "single":
      return [];
    case "first":
      return [MOVE_ACTIONS.bottom];
    case "last":
      return [MOVE_ACTIONS.top];
    case "middle":
      return [MOVE_ACTIONS.top, MOVE_ACTIONS.bottom];
    default:
      return [];
  }
};

const ActionsFilter = ({ openPopup, position, moduleId, moduleIdToScroll }) => {
  const dispatch = useDispatch();

  const dynamicActions = [BASE_ACTIONS.edit, ...getPositionActions(position), BASE_ACTIONS.delete];

  const handleActionSelect = (action) => {
    if (action.id === "edit" || action.id === "delete") {
      openPopup(action.id);
    } else if (action.id === "move_up" || action.id === "move_down") {
      dispatch(changeModulePosition({ direction: action.id, moduleId }));
      moduleIdToScroll.current = moduleId;
    }
  };

  return (
    <div className="select-box actions-dropdown" style={{ width: "105px" }}>
      <MultiSelectDropdown
        options={dynamicActions}
        selectedFilters={[]}
        placeholder="Action"
        numberDisplayed={0}
        keepOpen={false}
        multiple={false}
        includeFilter={false}
        onSelectChange={handleActionSelect}
      />
    </div>
  );
};

export default ActionsFilter;
